module.exports = __webpack_public_path__ + "static/img/system-1.28215e25.png";